import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import NewsService from '@/services/CmsServices/NewsService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    errors: null,
    successOnCreate: '',
};

export const viewNews = createAsyncThunk(
    'news/viewNews',
    async (newsId, { rejectWithValue }) => {
        try {
            const response = await NewsService.viewNews(newsId);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const createNews = createAsyncThunk(
    'news/createNews',
    async (data, { rejectWithValue }) => {
        try {
            const { id: newsId } = data;
            let response;
            if (newsId) {
                response = await NewsService.updateNews(data, newsId);
            } else {
                response = await NewsService.createNews(data);
            }
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const createNewsSlice = createSlice({
    name: 'createNews',
    initialState: model,
    reducers: {
        resetNewsStateData: (state) => {
            state.data = null;
        },
        resetNewsStateOnError: (state) => {
            state.errors = null;
        },
        resetNewsStateOnSuccess: (state) => {
            state.successOnCreate = '';
        },
    },
    extraReducers: (builder) => {
        // view news
        builder.addCase(viewNews.pending, (state) => {
            state.loading = true;
        }).addCase(viewNews.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewNews.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // create news
        builder.addCase(createNews.pending, (state) => {
            state.submitting = true;
        }).addCase(createNews.fulfilled, (state, action) => {
            state.submitting = false;
            const newsId = action.meta.arg.id;
            state.successOnCreate = newsId ? 'News updated successfully!' : 'News created successfully!';
            state.data = action.payload;
        }).addCase(createNews.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetNewsStateData,
    resetNewsStateOnError,
    resetNewsStateOnSuccess,
} = createNewsSlice.actions;

export default createNewsSlice.reducer;
